// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect } from 'react';
import { useDebounceCallback } from '@/hooks/use-debounce-callback';

const HEIGHT_DEBOUNCE_IN_MILLISECONDS = 100;

interface IFrameResizerProps {
  embeddedId?: string;
}

export const IframeResizer = ({ embeddedId }: IFrameResizerProps) => {
  const sendHeight = () => {
    const height = Math.ceil(document.body.scrollHeight);
    window.parent.postMessage({
      id: embeddedId,
      type: 'workee-iframe-resize',
      height,
    }, '*');
  };

  const sendHeightWithDebounceEffect = useDebounceCallback(
    sendHeight,
    HEIGHT_DEBOUNCE_IN_MILLISECONDS,
  );

  useEffect(() => {
    sendHeightWithDebounceEffect();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      throw new Error('window is missing for IframeResizer');
    }

    window.addEventListener('resize', sendHeightWithDebounceEffect);

    const observer = new MutationObserver(sendHeightWithDebounceEffect);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    return () => {
      window.removeEventListener('resize', sendHeightWithDebounceEffect);
      observer.disconnect();
    };
  }, [sendHeightWithDebounceEffect]);

  return null;
};
